import useGlobalStore from '../../store/globalStore'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosPrivate } from '../../api/axiosClient'
import { apiEndpoints, queryKeys } from '../../constants'

const useRecoverRemovedPic = (page, searchTerm, handleConfirmModalClose) => {
  const queryClient = useQueryClient()
  const showToastMessage = useGlobalStore((state) => state.showToastMessage)

  const { mutate, isLoading } = useMutation(
    (assetId) => axiosPrivate.post(`${apiEndpoints.recoverPic}/${assetId}`),
    {
      onSuccess: (response) => {
        const successMessage =
          response?.data?.message || 'Successfully updated the reported photo'

        showToastMessage(successMessage, 'success')
      },
      onError: (error) => {
        const errorMessage =
          error?.errors?.message ||
          'Error occurred while updating reported photo'

        showToastMessage(errorMessage, 'error')
      },
      onSettled: () => {
        handleConfirmModalClose()
        queryClient.invalidateQueries([
          queryKeys.reportedPics,
          page,
          searchTerm,
        ])
      },
    },
  )

  return {
    recoverRemovedPic: mutate,
    isRecoveringRemovedPic: isLoading,
  }
}

export default useRecoverRemovedPic
